import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  getKeyValue,
} from "@nextui-org/react";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import {
  useCreateHotWallet,
  useGetHotWallets,
} from "@/services/withdraw.service";
import { format } from "date-fns";

interface HotWallet {
  id: string;
  address: string;
  kmsKeyId: string;
  createdAt: string;
  updatedAt: string;
}

const HotWalletList = () => {
  const [tableRows, setTableRows] = useState<HotWallet[]>([]);

  // Get hot wallets data
  const { data: hotWalletsResponse, isLoading: isLoadingWallets } =
    useGetHotWallets();

  // Create wallet mutation
  const { mutate: createWallet } = useCreateHotWallet();

  useEffect(() => {
    if (hotWalletsResponse?.data) {
      console.clear();
      console.log(hotWalletsResponse.data.data);
      setTableRows(hotWalletsResponse.data.data);
    }
  }, [hotWalletsResponse]);

  const columns = [
    {
      key: "address",
      label: "Address",
    },
    {
      key: "kmsKeyId",
      label: "KMS ID",
    },
    {
      key: "createdAt",
      label: "Created Date",
    },
    {
      key: "actions",
      label: "Actions",
    },
  ];

  const handleCreate = () => {
    createWallet();
  };

  const handleWithdraw = (kmsId: string) => {
    // Will be implemented later
    console.log(kmsId);
  };

  if (isLoadingWallets) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return (
    <div>
      <div>
        <div className="font-ubuntu float-left text-center text-2xl text-sm font-semibold text-white sm:text-lg">
          <p className="hidden sm:block">Hot Wallet Management</p>
        </div>
        <div className="flex w-full flex-col gap-4">
          <div className="mb-6 mt-5 flex w-auto flex-wrap items-start gap-4 md:mb-0 md:flex-nowrap">
            <Button
              className="admin-common-button-gradient font-ubuntu w-40 rounded-md text-base font-bold"
              onClick={handleCreate}
            >
              Create Wallet
            </Button>
            <div className="float-right ml-96 ms-auto w-1/2"></div>
          </div>
        </div>
        <div className="w-full sm:mt-5">
          <div className="w-full overflow-x-auto">
            <Table
              removeWrapper
              className="table-striped table-striped-even table"
            >
              <TableHeader className="rounded-none" columns={columns}>
                {(column) => (
                  <TableColumn key={column.key}>
                    <div className="white-op flex">
                      {column.label}
                      <Button
                        isIconOnly
                        className="transparent-bg h-auto w-auto"
                      ></Button>
                    </div>
                  </TableColumn>
                )}
              </TableHeader>
              <TableBody items={tableRows}>
                {(item) => (
                  <TableRow key={item.id}>
                    {(columnKey) => (
                      <TableCell>
                        {columnKey === "actions" ? (
                          <Button
                            className="bg-red-500 text-white"
                            size="sm"
                            onClick={() => handleWithdraw(item.kmsKeyId)}
                          >
                            Withdraw
                          </Button>
                        ) : columnKey === "createdAt" ? (
                          <div>
                            {format(getKeyValue(item, columnKey), "dd/MM/yyyy")}
                          </div>
                        ) : (
                          <div>{getKeyValue(item, columnKey)}</div>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotWalletList;
